var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
		[ 'skin-' + _vm.skin ]: true,
		isStaging: _vm.isStaging,
	},staticStyle:{"display":"flex","flex-direction":"column","height":"100vh"},attrs:{"id":"app"}},[_c('Root',{key:_vm.key,ref:"root"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }